import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentimentAnalysisModule } from '../sentiment-analysis.module';
import type { SentimentAnalysisHomeComponent } from '../sentiment-analysis-home/sentiment-analysis-home.component';

/**
 * Default change detection: the template binds through a stable `[host]="this"` reference, so OnPush would
 * skip updates when only `host.heatmapLoading` / `host.heatmapData` etc. change after the async heatmap call.
 */
@Component({
  selector: 'app-sentiment-analysis-details-home',
  standalone: true,
  imports: [CommonModule, SentimentAnalysisModule],
  templateUrl: './sentiment-analysis-details-home.component.html',
  styleUrls: ['../sentiment-analysis-home/sentiment-analysis.layout.scss'],
})
export class SentimentAnalysisDetailsHomeComponent {
  /** Parent shell (`SentimentAnalysisHomeComponent`); `import type` avoids a circular runtime import. */
  @Input({ required: true }) host!: SentimentAnalysisHomeComponent;
}
